export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -22.ccf5a72a.png";